module.exports = __webpack_public_path__ + "static/img/jcoin02.8831241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jcoin02.png
// module id = 4QT9
// module chunks = 1